module.exports = __webpack_public_path__ + "static/media/h5-video.e4cfebc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/h5-video.mp4
// module id = NrsC
// module chunks = 0